"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable dot-notation */
const react_1 = __importStar(require("react"));
const Scrollable_1 = __importDefault(require("~/components/UI/Scrollable"));
const Chip_1 = __importDefault(require("./Chip"));
const Chips_module_scss_1 = __importDefault(require("./Chips.module.scss"));
const Carousel_1 = __importDefault(require("../Carousel"));
function Chips({ chips, onChange = () => {
    /* do nothing */
}, selected, }) {
    const chipChangeHandler = (value) => {
        onChange(value);
    };
    const scrollableDiv = (0, react_1.useRef)(null);
    return (react_1.default.createElement("div", { className: Chips_module_scss_1.default['container'] },
        react_1.default.createElement(Carousel_1.default, { ref: scrollableDiv },
            react_1.default.createElement(Scrollable_1.default, { direction: "horizontal" },
                react_1.default.createElement("div", { className: Chips_module_scss_1.default['chips'], ref: scrollableDiv }, chips.map((chip) => (react_1.default.createElement(Chip_1.default, Object.assign({ key: chip.id }, chip, { active: selected === chip.value, onClick: chipChangeHandler })))))))));
}
exports.default = Chips;
